import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, Radio, RadioGroup, FormControlLabel } from '@mui/material';
import './PublishEditModal.scss';
import LogicModal from '../LogicModal/LogicModal';

export default function PublishEditModal({ open, onClose, onOpenLogic, cardData }) {
  const [opinion, setOpinion] = useState('short');
  const [entryType, setEntryType] = useState('market');
  const [logicOpen, setLogicOpen] = useState(false);
  const [markPrice, setMarkPrice] = useState("");
  const [entry, setEntry] = useState("");
  const [stoploss, setStoploss] = useState("");
  const [target1, setTarget1] = useState("");
  const [target2, setTarget2] = useState("");
  const [leverage, setLeverage] = useState("");
  const [errors, setErrors] = useState({});

  /* AUTO FILL FROM CARD DATA */
  useEffect(() => { if (cardData) { setMarkPrice(cardData.price || ""); setEntry(cardData.price || ""); setTarget1(cardData.supportLow || ""); setTarget2(cardData.supportHigh || ""); setStoploss(cardData.risk || ""); setLeverage("5"); } }, [cardData]);

  const mp = Number(markPrice);
  const e = Number(entry);
  const entryPriceMin = mp ? (mp - mp * 0.10).toFixed(2) : "";
  const entryPriceMax = mp ? (mp + mp * 0.10).toFixed(2) : "";
  const entryRangeMin = e ? (e - e * 0.0075).toFixed(2) : "";
  const entryRangeMax = e ? (e + e * 0.0075).toFixed(2) : "";
  const validateTrade = () => {
    console.log('Validate trade');

    const errors = {};
    const e = Number(entry);
    const sl = Number(stoploss);
    const t1 = Number(target1);
    const t2 = Number(target2);
    const lev = Number(leverage);

    if (!e || !sl || !t1 || !t2 || !lev) {
      errors.general = "All fields are required";
      return errors;
    }

    if (opinion === "long" && sl >= e) {
      errors.stoploss = `For LONG, stoploss must be below ${e}`;
    }

    if (opinion === "short" && sl <= e) {
      errors.stoploss = `For SHORT, stoploss must be above ${e}`;
    }

    const slPercent = Math.abs((e - sl) / e) * 100;
    if (slPercent > 20) {
      const slMin = (e - e * 0.2).toFixed(2);
      const slMax = (e + e * 0.2).toFixed(2);
      errors.stoplossRange = `Stoploss must be between ${slMin} and ${slMax}`;
    }

    if (mp && (e < entryPriceMin || e > entryPriceMax)) {
      errors.entry = `Entry must be between ${entryPriceMin} and ${entryPriceMax}`;
    }

    let risk = 0;
    let expectedT1 = 0;
    let expectedT2 = 0;

    if (opinion === "long") {
      risk = e - sl;

      if (risk <= 0) {
        errors.stoploss = "For LONG, Stoploss must be below Entry";
        return errors;
      }

      expectedT1 = e + risk * 1.5;
      expectedT2 = e + risk * 2;

      if (t1 < expectedT1) {
        errors.target1 = `Target1 must be ≥ ${expectedT1.toFixed(2)} for 1:1.5 RR`;
      }

      if (t2 < expectedT2) {
        errors.target2 = `Target2 must be ≥ ${expectedT2.toFixed(2)} for 1:2 RR`;
      }

    } else {
      risk = sl - e;

      if (risk <= 0) {
        errors.stoploss = "For SHORT, Stoploss must be above Entry";
        return errors;
      }

      expectedT1 = e - risk;
      expectedT2 = e - risk * 1.5;

      if (t1 > expectedT1) {
        errors.target1 = `Target1 must be ≤ ${expectedT1.toFixed(2)} for 1:1.5 RR`;
      }

      if (t2 > expectedT2) {
        errors.target2 = `Target2 must be ≤ ${expectedT2.toFixed(2)} for 1:2 RR`;
      }
    }

    return errors;
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 3,
            width: { xs: "100%", sm: "95%", md: "850px" },
            margin: { xs: "10px auto", sm: "20px auto" }
          }
        }}
      >

        <DialogContent className="custom-modal">
          {/* HEADER */}
          <div className="modal-header">
            <h2>{cardData?.coin}</h2>

            <div className="price">
              ${cardData?.price}

              <span className="potential">
                ▲{cardData?.change} ({cardData?.percent}%)
              </span>
            </div>

            <div className="date">
              {cardData?.date}
            </div>
          </div>
          <div className="card-divider"></div>
          <div className="form-grid">
            {/* <div className="form-group col-12">
              <label>Mark Price (For Testing Only) *</label>
              <input
                className="entry-input"
                placeholder="Enter Mark Price"
                value={markPrice}
                onChange={(e) => setMarkPrice(e.target.value)}
              />
            </div> */}
          </div>

          <div className="form-group">&nbsp;&nbsp;</div>

          <div className="form-grid">
            <div className="form-group col-6">
              <label>My Opinion *</label>
              <div className="toggle-group">
                <button className={opinion === 'long' ? 'active' : ''} onClick={() => setOpinion('long')} >
                  LONG
                </button>

                <button className={opinion === 'short' ? 'active' : ''} onClick={() => setOpinion('short')} >
                  SHORT
                </button>
              </div>
            </div>

            {/* Entry */}

            <div className="form-group col-12">
              <label>Entry Price *</label>
              <div className="two-input">
                <input
                  className="entry-input"
                  placeholder="LTP"
                  value={entry}
                  onChange={(e) => setEntry(e.target.value)}
                />
                <RadioGroup row value={entryType} onChange={(e) => setEntryType(e.target.value)} >
                  <FormControlLabel className="radio-label" value="market" control={<Radio size="small" />} label="Market" />
                  <FormControlLabel className="radio-label" value="limit" control={<Radio size="small" />} label="Limit" />
                </RadioGroup>
              </div>
              <div className="sub-lines"> Must be within ±10% of mark price</div>
              {errors.entry && <div className="error-text">{errors.entry}</div>}
            </div>

            {/* Validity */}
            <div className="form-group col-12">
              <label>Validity *</label>
              <input type="date" />
              <div className="sub-lines">&nbsp;</div>
            </div>

            {/* Entry Range */}
            <div className="form-group col-6">
              <label>Entry Range *</label>
              <div className="two-input">
                <input className="entry-input" readOnly value={entryRangeMin} placeholder="₹ 90" />
                <input className="entry-input" readOnly value={entryRangeMax} placeholder="₹ 100" />
              </div>
            </div>

            {/* Leverage */}
            <div className="form-group col-12">
              <label>Leverage *</label>
              <input
                placeholder="0X"
                value={leverage}
                onChange={(e) => setLeverage(e.target.value)}
              />

              <div className="sub-lines"> Maintain leverage above 2x </div>
              {errors.leverage && <div className="error-text">{errors.leverage}</div>}
            </div>

            {/* Targets */}
            <div className="form-group col-6">
              <div className="two-input">
                <span>
                  <label>Target 1 *</label>
                  <input
                    className="entry-input"
                    placeholder="₹ 100"
                    value={target1}
                    onChange={(e) => setTarget1(e.target.value)}
                  />
                  <div className="sub-lines"> RR- 1:1.5; min. 2.5% </div>
                  {errors.target1 && <div className="error-text">{errors.target1}</div>}
                </span>
                <span>
                  <label>Target 2 *</label>
                  <input
                    className="entry-input"
                    placeholder="₹ 100"
                    value={target2}
                    onChange={(e) => setTarget2(e.target.value)}
                  />
                  <div className="sub-lines"> RR-1:2; min. 4%</div>
                  {errors.target2 && <div className="error-text">{errors.target2}</div>}
                </span>
              </div>
            </div>

            {/* <div className="form-group col-12">&nbsp;</div> */}
            {/* Stoploss */}

            <div className="form-group col-12">
              <label>Stoploss *</label>
              <input
                placeholder="₹ 200"
                value={stoploss}
                onChange={(e) => setStoploss(e.target.value)}
              />
              <div className="sub-lines"> Must be within ±20% of Entry </div>
              {errors.stoploss && <div className="error-text">{errors.stoploss}</div>}
              {errors.stoplossRange && <div className="error-text">{errors.stoplossRange}</div>}
            </div>
          </div>
          <div className="footer-info">
            Scalping, defined as a very short-duration trade setup designed
            to capture small price movements within minutes to a few hours,
            typically targeting low percentage gains with tight stop-loss
            levels, is strictly not permitted on CryptoAnts
          </div>
          {/* Footer */}
          <div className="modal-footer">
            <button className="logic-btn" onClick={() => {
              const validationErrors = validateTrade();
                  if (Object.keys(validationErrors).length > 0) {
                    setErrors(validationErrors); return;
                  }
              setErrors({});
              setLogicOpen(true);
              onClose();
            }}
            >
              LOGIC
            </button>

          </div>

          {errors.general && (
            <div className="error-text" style={{ textAlign: "center", marginTop: '20px', marginBottom: "10px" }}>
              {errors.general}
            </div>
          )}

        </DialogContent>

      </Dialog>

      <LogicModal open={logicOpen} onClose={() => { setLogicOpen(false); }} />
    </>
  );
}